import React, {FC, Fragment, useCallback, useEffect, useRef, useState} from "react";
import cls from "./category.module.scss";
import InputRange, {Range} from "react-input-range";
import {ICurrencies} from "../Wrappers/MainLayout";
import {useRouter} from "next/router";
import useDebounce from "../../../hooks/useDebounce";

interface IFilterRangeProps {
    data: { min: number, max: number };
    title: string,
    selectedRate: ICurrencies
}

const CustomFilterRange: FC<IFilterRangeProps> = (
    {
        data: {min, max} = {min: 0, max: 0},
        title,
        selectedRate: {symbol: selectedCurrSymbol = ""} = {}
    }
) => {
    const { query: { filter_price = `${min},${max}`, ...otherQuery }, push: routerPush } = useRouter();

    const priceRange = String(filter_price).split(",").map(Number);
    const safeFrom = !isNaN(priceRange[0]) ? priceRange[0] : min;
    const safeTo = !isNaN(priceRange[1]) ? priceRange[1] : max;

    const [[stateFrom, stateTo], setState] = useState<string[]>([
        safeFrom.toString(),
        safeTo.toString()
    ]);

    const debouncedUpdate = useDebounce((newMin: number, newMax: number) => {
        routerPush(
            {query: {...otherQuery, filter_price: `${newMin},${newMax}`}},
            undefined,
            {scroll: false}
        );
    }, 1000);

    const handleChange = ({min: newFrom, max: newTo}: Range) => {
        setState([newFrom.toString(), newTo.toString()]);
    };

    const handleCompleteChange = ({min: newFrom, max: newTo}: Range) => {
        debouncedUpdate(newFrom, newTo);
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>, type: "min" | "max") => {
        const {target: {value}} = e || {};
        const debounceInfoHandle = (array: string[]) => {
            const [insideMin, insideMax] = array
            setState(array);
            const parsedMin = parseInt(insideMin) || min;
            const parsedMax = parseInt(insideMax) || max;
            debouncedUpdate(parsedMin, parsedMax);
        }

        debounceInfoHandle(type === "min" ? [value, stateTo] : [stateFrom, value])
    };

    const handleInputBlur = () => {
        const newMin = parseInt(stateFrom) || min;
        const newMax = parseInt(stateTo) || max;
        setState([newMin.toString(), newMax.toString()]);
        routerPush(
            {query: {...otherQuery, filter_price: `${newMin},${newMax}`}},
            undefined,
            {scroll: false}
        );
    };

    return (
        <div className={cls["filter-price"]}>
            <div className={cls.widget__title}>{title}</div>
            {max ? (
                <Fragment>
                    <div className={`${cls["filter-price__slider"]} ${min === max ? cls.same_min_max : ""}`} dir="ltr">
                        <InputRange
                            minValue={min}
                            maxValue={max}
                            value={{min: parseInt(stateFrom) || min, max: parseInt(stateTo) || max}}
                            step={1}
                            onChange={handleChange as (value: Range | number) => void}
                            onChangeComplete={handleCompleteChange as (value: Range | number) => void}
                        />
                    </div>
                    <div className={`${cls["filter-price__inputs"]} ${min === max ? cls.same_min_max : ""}`} dir="ltr">
                        <div className={cls["input__container"]}>
                            <span>{selectedCurrSymbol}</span>
                            <input
                                type="text"
                                value={stateFrom}
                                placeholder={"Min"}
                                onChange={(e) => handleInputChange(e, "min")}
                                onBlur={handleInputBlur}
                            />
                        </div>
                        <div className={cls["input__container"]}>
                            <span>{selectedCurrSymbol}</span>
                            <input
                                type="text"
                                value={stateTo}
                                placeholder={"Max"}
                                onChange={(e) => handleInputChange(e, "max")}
                                onBlur={handleInputBlur}
                            />
                        </div>
                    </div>
                </Fragment>
            ) : null}
        </div>
    );
};

export default CustomFilterRange;